var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ais-hits',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var items = ref.items;
return _c('div',{},_vm._l((items),function(item){return _c('SearchResult',{key:item.objectID,attrs:{"item":item}})}),1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }